import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Comportamento de TODO botão "Voltar" do app: volta para a tela de onde o
 * usuário veio; se não houver de onde (página aberta por link direto, favorito,
 * nova aba), vai para `fallback` — o "pai" lógico da tela.
 *
 * Como sabe se houve navegação dentro do app: o React Router (v6) marca a
 * PRIMEIRA entrada da sessão com `location.key === "default"`. Qualquer outra
 * chave significa que existe uma tela do próprio app antes desta no histórico
 * — então `navigate(-1)` nunca tira o usuário do sistema. Recarregar a página
 * (F5) preserva a chave, então o comportamento se mantém.
 *
 * `navigate(-1)` puro, sem essa checagem, levaria para fora do app quando a tela
 * foi aberta direto.
 */
export function useGoBack(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key !== "default") navigate(-1);
    else navigate(fallback, { replace: true });
  }, [location.key, navigate, fallback]);
}
